import { colors } from '../../../../utils'

export const styles = {
  modal: {
    width: '1100px',
    maxWidth: '95vw',
    boxSizing: 'border-box',
  },
  // BaseModal's default body padding (24px) doesn't match its header padding (20px),
  // which reads as the title and the body content being misaligned. Override it here
  // so both share the same left/right padding as the header.
  body: {
    borderTop: `1px solid ${colors.greyStrong}`,
    marginTop: '10px',
    paddingTop: '12px',
    paddingRight: '20px',
    paddingLeft: '20px',
    boxSizing: 'border-box',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '12px',
  },
  observationText: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    maxHeight: '80px',
    overflowY: 'auto',
    color: colors.greyStrong,
  },
  viewer: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '8px',
  },
  navButton: {
    '&.MuiIconButton-root': {
      backgroundColor: colors.disabledBorder,
      flexShrink: 0,
    },
  },
  imageBox: {
    flex: 1,
    height: '70vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.disabledLighten,
    borderRadius: '4px',
    overflow: 'hidden',
  },
  image: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
  thumbStrip: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    justifyContent: 'center',
  },
  thumb: {
    width: '56px',
    height: '56px',
    borderRadius: '4px',
    overflow: 'hidden',
    border: `2px solid transparent`,
    cursor: 'pointer',
    backgroundColor: colors.disabledLighten,
  },
  thumbActive: {
    borderColor: colors.primary,
  },
  thumbImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
}

export default styles
